export default [{
    path: '/publicPage/unloadingRangeSetting',
    name: 'unloadingRangeSetting',
    component: () => import( /* webpackChunkName: "common" */ './unloadingRangeSetting.vue'),
    meta: {
        authPass: true,
        title: '卸货范围设置',
        headerId: 'myFortune'
    }
}];